// extracted by mini-css-extract-plugin
module.exports = {"root":"SGSMiniCard_root__1xP1V","underline":"SGSMiniCard_underline__35-zw"};